import { useQuery } from "@tanstack/react-query";
import queryKey from "../enumerations/queryKey";
import { getUserInfo } from "./service";

export const useGetUserInfo = (options) => {
  return useQuery(
    [queryKey.USER_INFO],
    () => getUserInfo({}).then((res) => res.data.data),
    {
      ...options,
    }
  );
};
